import { Component, HostListener, Inject, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AckDialogData } from './ack-dialog-data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-ack-dialog',
    templateUrl: './ack-dialog.component.html',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule]
})
export class AckDialogComponent implements OnInit {
    private matDialogRef = inject(MatDialogRef<AckDialogComponent>);

    constructor(
        @Inject(MAT_DIALOG_DATA) public ackDialogData: AckDialogData
    ) { }

    ngOnInit() {
    }

    ack() {
        this.close('ack');
    }

    close(value: any) {
        this.matDialogRef.close(value);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }
}